import React, {useCallback, useState} from 'react';
import 'react-lazy-load-image-component/src/effects/blur.css';
import faqData from "../../data/faqLahalleData";
import faqIncluviaData from "../../data/faqIncluviaData";
import Parser from "html-react-parser";

import mobileMenuData from "../../data/mobileMenuData";

const CLASS_NAMES = {
    ACTIVE: 'active',
    ACTIVE_BLOCK: 'active-block',
    CURRENT: 'current',
};


function FaqPopUpLahalle({page}) {
    const [activeIndex, setActiveIndex] = useState(null);
    const [searchText, setSearchText] = useState("");

    const handleClick = useCallback((index) => {
        setActiveIndex(prevIndex => prevIndex === index ? null : index);
    }, []);

    const dataMapping = {
        lahalle: faqData,
        incluvia: faqIncluviaData.slice(0, 10),
    };


    const filteredFaq = (dataMapping[page] || []).filter(item =>
        item.question.toLowerCase().includes(searchText.toLowerCase()) ||
        item.answer.toLowerCase().includes(searchText.toLowerCase())
    );

    return (
            <>
                <h2 className="libre-title mb-2">FAQ : <span>réponses aux questions fréquentes</span></h2>
                <div className="faq-search" style={{ marginBottom: '20px' }}>
                    <input
                        type="text"
                        placeholder="Rechercher une question..."
                        value={searchText}
                        onChange={e => setSearchText(e.target.value)}
                        className="form-control"
                    />
                </div>
                <section className="faqs-section layout-pt-0 ">
                    <div className="auto-container">

                        <ul className="accordion-box">
                            {filteredFaq.map((item, index) => (
                                <li
                                    key={index}
                                    className={`accordion block ${
                                        activeIndex === index ? CLASS_NAMES.ACTIVE_BLOCK : ''
                                    }`}
                                >
                                    <div
                                        className={`nunito acc-btn ${
                                            activeIndex === index ? CLASS_NAMES.ACTIVE : ''
                                        }`}
                                        onClick={() => handleClick(index)}
                                    >
                                        {index + 1} - {item.question}
                                        <span className="icon flaticon-add"></span>
                                    </div>
                                    <div
                                        className={`nunito acc-content ${
                                            activeIndex === index ? CLASS_NAMES.CURRENT : ''
                                        }`}
                                    >
                                        <div className="content">

                                            <p>{Parser(item.answer)}</p>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </section>
            </>
    );
}

export default FaqPopUpLahalle;
